import React, {useEffect, useState} from 'react';
import './App.scss';
import { NavLink, useRouteMatch } from "react-router-dom";
import ProjectDatabase from "./helper/ProjectDatabase";
import UrlHelper from "./helper/UrlHelper";
import { LINK_ALL_CATEGORIES_RELATIVE } from "./helper/Constants";

function SecondaryNav(props) {
    const { path, url} = useRouteMatch();
    const [projectCategories, setProjectCategories] = useState([]);
    useEffect(() => {
        (async () => {
            let response = await ProjectDatabase.getAllProjectCategories();
            let categories = response.data;
            setProjectCategories(categories);
        })()
    }, [])

    return (
        <ul className="secondary-navbar">
            {projectCategories.map((projectCategory) => (
                <li key={projectCategory.url_id}>
                    <NavLink to={UrlHelper.join(url, UrlHelper.join(LINK_ALL_CATEGORIES_RELATIVE, projectCategory.url_id))} activeClassName="selected-navitem">
                        {projectCategory.name.toUpperCase()}
                    </NavLink>
                </li>
            ))
            }
        </ul>
    );
}

export default SecondaryNav;
